var _defs, _circle, _ellipse, _ellipse2, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82.67,
    cy: 82.67,
    r: 67,
    transform: "rotate(-15 82.67 82.67)",
    stroke: "#9086E2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.078,
    cy: 66.501,
    rx: 7,
    ry: 12,
    transform: "rotate(-15 56.078 66.501)",
    fill: "#9086E2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.613,
    cy: 55.372,
    rx: 7,
    ry: 12,
    transform: "rotate(-15 97.613 55.372)",
    fill: "#9086E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.465 107.349c12.752 11.876 26.878 15.12 43.616 10.016 15.734-4.798 24.995-14.025 29.794-29.687M41.512 108.712c3.819 1.411 6.689.945 8.86-1.439 2.043-2.241 2.365-4.871 1.04-8.46",
    stroke: "#9086E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.105 84.706c-2.601 3.132-5.32 4.163-8.393 3.184-2.889-.92-4.483-3.035-5.129-6.807",
    stroke: "#9086E2"
  })));
}

var MemoSvgSmile = /*#__PURE__*/React.memo(SvgSmile);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTY2IiBoZWlnaHQ9IjE2NiIgdmlld0JveD0iMCAwIDE2NiAxNjYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjgyLjY3MDMiIGN5PSI4Mi42NzAxIiByPSI2NyIgdHJhbnNmb3JtPSJyb3RhdGUoLTE1IDgyLjY3MDMgODIuNjcwMSkiIHN0cm9rZT0iIzkwODZFMiIvPgo8ZWxsaXBzZSBjeD0iNTYuMDc4MiIgY3k9IjY2LjUwMTEiIHJ4PSI3IiByeT0iMTIiIHRyYW5zZm9ybT0icm90YXRlKC0xNSA1Ni4wNzgyIDY2LjUwMTEpIiBmaWxsPSIjOTA4NkUyIi8+CjxlbGxpcHNlIGN4PSI5Ny42MTM0IiBjeT0iNTUuMzcxNyIgcng9IjciIHJ5PSIxMiIgdHJhbnNmb3JtPSJyb3RhdGUoLTE1IDk3LjYxMzQgNTUuMzcxNykiIGZpbGw9IiM5MDg2RTIiLz4KPHBhdGggZD0iTTUwLjQ2NDggMTA3LjM0OUM2My4yMTY3IDExOS4yMjUgNzcuMzQyOSAxMjIuNDY5IDk0LjA4MSAxMTcuMzY1QzEwOS44MTUgMTEyLjU2NyAxMTkuMDc2IDEwMy4zNCAxMjMuODc1IDg3LjY3ODQiIHN0cm9rZT0iIzkwODZFMiIvPgo8cGF0aCBkPSJNNDEuNTExNyAxMDguNzEyQzQ1LjMzMDcgMTEwLjEyMyA0OC4yMDA2IDEwOS42NTcgNTAuMzcyOCAxMDcuMjczQzUyLjQxNDcgMTA1LjAzMiA1Mi43Mzc1IDEwMi40MDIgNTEuNDExMiA5OC44MTI0IiBzdHJva2U9IiM5MDg2RTIiLz4KPHBhdGggZD0iTTEzMS4xMDUgODQuNzA2MUMxMjguNTA0IDg3LjgzNzUgMTI1Ljc4NSA4OC44Njg4IDEyMi43MTIgODcuODkwNUMxMTkuODIzIDg2Ljk3MDggMTE4LjIyOSA4NC44NTQ2IDExNy41ODMgODEuMDgyNiIgc3Ryb2tlPSIjOTA4NkUyIi8+Cjwvc3ZnPgo=";
export { MemoSvgSmile as ReactComponent };